/**
 * Create a new media file for download.
 *
 * {@link https://github.com/netmedialtd/rebilly-frontend/blob/master/src/core/media/media.js on github}
 */
import uniqueNumber from '@/common/helpers/unique-number';

export default class Media {
    /**
     * Create a new media file for download
     * @param mimeType string
     * @param fallbackMimeType string
     * @param data {*}
     * @param fileName string
     */
    constructor({
        mimeType, fallbackMimeType = null, data = null, fileName = null,
    }) {
        this.mimeType = mimeType;
        this.fallbackMimeType = fallbackMimeType || this.mimeType;
        this.data = data;
        this.fileName = fileName;
        return this;
    }

    get hasRequiredData() {
        return this.data !== null;
    }

    /**
     *
     * @returns {string}
     * @private
     */
    static generateRandomFileName() {
        return `file-${new Date().getTime()}${uniqueNumber}`;
    }

    /**
     * Trigger a browser download for this media file
     * @returns {boolean}
     */
    triggerDownload() {
        if (!this.hasRequiredData) {
            throw new Error(`Empty data`);
        }
        if (this.fileName === null) {
            this.fileName = Media.generateRandomFileName();
        }
        try {
            const blob = new Blob([this.data], {type: this.mimeType});
            // only in IE10+
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, this.fileName);
            } else {
                const link = document.createElement('a');
                // check for download attribute support
                if (link.download !== undefined) {
                    const url = URL.createObjectURL(blob);
                    link.setAttribute('download', this.fileName);
                    link.setAttribute('href', url);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    // fallback for when nothing else works
                    const csvContent = `data:${this.fallbackMimeType},${this.data}`;
                    const encodedUri = encodeURI(csvContent);
                    window.open(encodedUri);
                }
            }
            this.data = null;
            return true;
        } catch (err) {
            throw new Error(err);
        }
    }
}
